import { render, staticRenderFns } from "./crudBlocks.vue?vue&type=template&id=4ee44a59"
import script from "./crudBlocks.vue?vue&type=script&lang=js"
export * from "./crudBlocks.vue?vue&type=script&lang=js"
import style0 from "./crudBlocks.vue?vue&type=style&index=0&id=4ee44a59&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports